import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  excerpt: string;
  date: string;
  image: string;
  category: string;
}

export default function ArticleCard({ id, title, excerpt, date, image, category }: ArticleCardProps) {
  return (
    <Link to={`/article/${id}`} className="group block cursor-pointer">
      <div className="rounded-lg overflow-hidden bg-background-200/50 hover:bg-background-200/80 transition-all duration-300">
        <div className="aspect-video overflow-hidden">
          <img
            src={image}
            alt={title}
            title={title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
        </div>
        <div className="p-4 md:p-5">
          <div className="flex items-center gap-2 mb-2">
            <span className="px-2 py-0.5 text-xs rounded bg-secondary-100/20 text-secondary-400 whitespace-nowrap">
              {category}
            </span>
            <span className="text-xs text-foreground-600">{date}</span>
          </div>
          <h3 className="text-sm md:text-base font-medium text-foreground-100 group-hover:text-primary-400 transition-colors line-clamp-2 mb-2">
            {title}
          </h3>
          <p className="text-xs md:text-sm text-foreground-500 line-clamp-2 leading-relaxed">
            {excerpt}
          </p>
        </div>
      </div>
    </Link>
  );
}